package de.oevbs.kunde.kundenportal2.services.registration.store

import de.oevbs.kunde.kundenportal2.RetrieveUserStep
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.registration.RetrieveUser
import de.oevbs.kunde.kundenportal2.services.registration.ResetUserPassClient
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.SimpleHandler
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class RetrieveUserStore(job: Job) : ValidatingStore<RetrieveUser, RetrieveUserStep, ComponentValidationMessage>(
    initialData = RetrieveUser(),
    validation = RetrieveUser.validation,
    metadataDefault = RetrieveUserStep.PARTNER1,
    validateAfterUpdate = false,
    job = job
) {

    private val client = ResetUserPassClient()

    private val progressStore = storeOf(RetrieveUserStep.PARTNER1, job)
    val currentStep: Flow<RetrieveUserStep> = progressStore.data

    /**
     * Setzt den aktuellen Step. Ändert nichts am Reset-Datenmodell.
     */
    val setStep = progressStore.update

    /**
     * Handler Step 1: handlePartner
     * Schritt 1: User hat seine Partnernummer eingegeben.
     *
     * Dieser Handler validiert die Eingabe mit Step1-Metadaten, um die Partner-ID des Benutzers zu validieren.
     * Wenn die Id gültig ist, sendet [checkPartnerSendMail] sie an den Server und wartet auf eine Antwort.
     * Der nächste Schritt ist bei Erfolg eine messagePage, die dem Benutzer mitteilt, dass der Server ihn identifizieren
     * konnte die Mail verschickt wurde. Der Button zeigt den Ladestatus während des Serveraufrufs an.
     */
    val handlePartner: SimpleHandler<Unit> = handle { retrieveUser ->

        GlobalServiceMessagesStore.clear()

        if (!validate(retrieveUser, RetrieveUserStep.PARTNER1).valid) {
            return@handle retrieveUser
        }

        val success = globalSubmitTracker.track {
            checkPartnerSendMail(retrieveUser.partner)
        }

        if (success) {
            progressStore.update(RetrieveUserStep.PARTNERVALID2)
            RetrieveUser()
        } else retrieveUser
    }

    /**
     * checkPartnerSendMail
     * Wird vom Schritt-1-Handler aufgerufen. Diese Funktion sendet die eingegebene Partnernummer an den Server und
     * wartet auf das Antwortobjekt. Bei Erfolg sendet der Server eine Mail an den Benutzer, die einen Link zu seinem
     * Usernamen enthält (fachliche Vorgabe
     * @param partnerId Die Partner-ID, die an den Server gesendet werden soll
     * @return true bei Erfolg, wenn die Partner-ID gefunden wurde, false bei jedem Fehler
     */
    private suspend fun checkPartnerSendMail(partnerId: String): Boolean {
        tryCatchAndHandleErrors("Schritt 1 von RetrieveUser") {
            client.sendUserForgottenMail(partnerId)
        } ?: return false

        return true
    }
}